import getTableColumnCountForCells from '../utils/getTableColumnCountForCells';
export default function setTableColumnWidth(editor, tableId, columnIndex, width) {
  editor.select();
  var cells = editor.getTableCells(tableId);
  var columnCount = getTableColumnCountForCells(cells);
  var resizedCells = editor.getTableCells(tableId).filter(function (_cell, i) {
    return i % columnCount === columnIndex;
  });
  return editor.withoutNormalizing(function () {
    resizedCells.forEach(function (cell) {
      return editor.setNodeByKey(cell.key, {
        data: cell.data.set('width', width)
      });
    });
  });
}